<template>
  <div class="entryPageMain">
    <div class="entryPage-Con">
      <div class="ep-top">
        <div class="doc-info shadow-box">
          <div class="doc-info-h"></div>
          <div class="doc-info-con">
            <div class="doc-pic">
              <img :src="userPhoto" @error="changeToDefaultImg" alt="">
            </div>
            <h2>{{info.userName}}</h2>
            <div class="doc-label"><span>{{info.deptName}}</span><span>{{info.regionNum}}</span></div>
            <p>今日共有<strong>{{meetingNum}}</strong>个会议</p>
          </div>
        </div>
        <div class="entrance shadow-box">
          <div class="doc-title">快捷入口</div>
          <ul class="entrance-list1">
            <li v-for="(item,index) in option">
              <router-link class="linkto" :to="linkTo1[index]" >
                <div :class="['choose',classes[index]]"><i :class="['img','iconfont',imgUrl[index]]" style="font-size: 40px !important; position: relative; top: 20px;color: #fff;"></i></div>
                <p>{{item}}</p>
              </router-link>
            </li>
          </ul>
          <ul class="entrance-list2">
            <li v-for="item in readMeetList" :class="{'invalid':item.status ===1 ||item.status ===2 }" :key="item.id">
                <span class="entrance-main">
                  <i class="square"></i>
                  <strong v-if="item.status==3">[进行中]</strong>
                  {{item.confName}}
                </span>
                <!-- 会议状态（0-未开始 1-结束 3-进行中） -->
                <span class="enter noEnter" v-if="item.status ===1 ||item.status ===1" >进入</span>
                <span class="enter " v-else @click="gotoMeeting(item)" >进入</span>
                <div class="clear"></div>
            </li>
          </ul>
        </div>
        <div class="data-statistic shadow-box">
          <div class="doc-title">数据统计</div>
          <ul class="statistics">
            <li :class="statisticClass[Math.floor(index/2)]"  v-for="(item,key,index) in statistics"><span></span><div class="statistics-data"><strong>{{item}}</strong><p>{{statisticLabal[index]}}</p></div></li>
          </ul>
        </div>
      </div>
      <div class="ep-bottom">
        <div class="calendar shadow-box">
          <div class="doc-title dp-title">
            <p>每日读片 <strong>{{dupian.everyday}}</strong></p><span></span><p>专题读片 <strong>{{dupian.special}}</strong></p>
          </div>
          <!--<el-date-picker
            class="calendar-date"
            v-model="calendar"
            type="datetime"
            placeholder="选择日期时间">
          </el-date-picker>-->
          <DatePicker v-if="showDatePicker"
                      :date="dpDate"
                      :min-date="minDate"
                      :max-date="maxDate"
                      @_getDay="_getDay">
          </DatePicker>
        </div>
        <div class="meeting shadow-box">
          <el-tabs style="height:100%;"  v-model="activeName" @tab-click="tabClick">
            <el-tab-pane label="今日会议" style="height:100%" name="first">
              <div class="epTable" style="height:100%">
                <pTable :cellClassName="cellClassName" :autoheight="pHeight" :head="head" :data="data" :dynamicOperationName="'entryPage'" :operation="operation" @_operation="_operation_" :operationWidth="operationWidth"></pTable>
              </div>
            </el-tab-pane>
            <el-tab-pane  label="明日会议" name="second">
              <div class="epTable" style="height:calc(54vh - 109.4px);max-height:420px;min-height:235.8px;">
                <pTable :cellClassName="cellClassName" :autoheight="pHeight" :head="head" :data="data" :dynamicOperationName="'entryPage'" :operation="operation" @_operation="_operation_" :operationWidth="operationWidth"></pTable>
              </div>
            </el-tab-pane>
            <el-tab-pane  label="一周以内" name="third">
              <div class="epTable" style="height:calc(54vh - 109.4px);max-height:420px;min-height:235.8px;">
                <pTable :cellClassName="cellClassName" :autoheight="pHeight" :head="head" :data="data" :dynamicOperationName="'entryPage'" :operation="operation" @_operation="_operation_" :operationWidth="operationWidth"></pTable>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>

      <!--输入密码-->
      <passwordInput v-show="popPassword" :isShowPassword="popPassword" @clossPassword="_cancelPass" @inputPassword="_inputDetail"></passwordInput>

    </div>
  </div>
</template>
<script type="text/ecmascript-6">
  import http from '@/api/http'
  import * as _ from '@/common/js/config'
  import pTable from '@/components/common/tables/publicTable'
  import {message} from '@/common/js/messages';
  import DatePicker from '@/components/common/fullCalendar/DatePicker'
  import {getLocalStorage, saveLocalStorage} from '@/common/js/localStorage'
  import pops from '@/components/common/pops/pop'
  import passwordInput from '@/components/common/message/passwordInput';
  import defalutImg from "@/assets/images/user.png";
  export default {
    components:{
      pTable,
      DatePicker,
      pops,
      passwordInput
    },
    data() {
      return {
        option:['添加病例','添加课件','新建课程','新建会议'],
        linkTo1:['/Homepage/MedicalRecord/newMedicalRecord?flag=0','/Homepage/CourseWare/AddCourseWare','/Homepage/TeachManage/NewCourse','/Homepage/ManageMeeting/AddManageMeeting'],
        classes: ['medicalRecord', 'courseWare', 'course','conference'],
        imgUrl:['icon-tianjiabingli','icon-tianjiakejian','icon-xinjiankecheng','icon-xinjianhuiyi'],
        readMeetList:[],
        statisticClass:['statistic1','statistic2','statistic3'],
        statisticLabal:['公共病例','我的病例','课件总量','我的课件','课程总量','我的课程'],
        info:{},
        statistics:{
          publicCase:0,
          myCase:0,
          courseware:0,
          myCourseware:0,
          curriculum:0,
          myCurriculum:0,
        },
        head: [
          {
            props: 'confName',
            label: '会议名称',
            width: '12%'
          },{
            props: 'startDateStr',
            label: '开始时间',
            width: '10%'
          },{
            props: 'confChairName',
            label: '主持人',
            width: '6%'
          },
          {
            props: 'confAddress',
            label: '会议地点',
            width: '8%'
          },
          {
            props: 'statusName',
            label: '会议状态',
            width: '8%'
          },
        ],
        data:[],
        operation:[
          {
            operation: '',
            class: 'icon-jinru',
            class2: 'icon-jinru hui',
            title: '进入'
          },
        ],
        meetingNum:0,
        activeName:'first',
        //pHeight:'245px',
        pHeight:'100%',
        operationWidth:'60px',
        calendar:'',
        /*日历*/
        dpDate: '2017-09-11',
        minDate: '2000-09-11',
        maxDate: '2020-09-11',
        showDatePicker: true,
        selectedDate: '点击选择日期',
        dupian:{
          everyday:0,
          special:0,
        },
        ConfPassword: '', //会议密码
        popPassword: false,//是否显示密码组件
        userPhoto:"",//用户头像
      }
    },
    methods: {
      changeToDefaultImg(){
        this.userPhoto = defalutImg;
      },
      getUserInfo(){
        http.post('/getUserInfo.json').then(res => {

          if (res.data.code === _.ERR_OK) {
            this.info = res.data.model
            this.userPhoto = res.data.model.userPhoto?res.data.model.userPhoto:"";
          }
        }).catch(err => {})
      },
      cellClassName({row, rowIndex,column,columnIndex}) {
        if (row.statusName === '进行中' && column.label === '会议状态') {
          return 'color-red';
        } else if (row.statusName === '未开始' && column.label === '会议状态') {
          return 'color-green';

        }
      },
      //按日期查询专题会议列表
      getMeetListByDateTime(){
        let startDateStr=this.getDay(0);
        let endDateStr=this.getDay(0);
        if(this.activeName === "second"){
          startDateStr=this.getDay(1);
          endDateStr=this.getDay(1)
        }else if(this.activeName === "third"){
          //查询一周内数据
          //先判断当前日期
          const now = new Date();
          const day = now.getDay()=== 0 ?7:now.getDay();//当前星期。返回值是 0（周日） 到 6（周六） 之间的一个整数。
          startDateStr=this.getDay(1-day)
          endDateStr=this.getDay(7-day)
        }
        this.data =[];
        const params={startDateStr,endDateStr};
        http.post('/meetIndex/getMeetListByDateTime.json', params).then(res => {
          if (res.data.code === _.ERR_OK) {
            const data = res.data.model;
            if(data && data.length>0){
              data.forEach(item=>{
                //会议状态（0-未开始 1-结束 3-进行中）
                const status =  item.status;
                if(status === 0 ){
                  item.statusName = "未开始";
                }else if(status === 1){
                  item.statusName = "结束";
                }else{
                  item.statusName = "进行中";
                }
              })
              this.data = data;
            }


          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e=>{
        //  this.$message.error(`网络错误，${e}`);
        });
      },
      //数据统计接口
      getCaseCourseCount(){
        http.post('/meetIndex/getCaseCourseCount.json', {}).then(res => {
          if (res.data.code === _.ERR_OK) {
            const data = res.data.model;
            const {commonCase,myCase,materiaAllCount,myMateria,courseAllCount,myCourse} = data;
            this.statistics.publicCase=commonCase;
            this.statistics.myCase=myCase;
            this.statistics.courseware=materiaAllCount;
            this.statistics.myCourseware=myMateria;
            this.statistics.curriculum=courseAllCount;
            this.statistics.myCurriculum=myCourse;
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch(e=>{
        //  this.$message.error(`网络错误，${e}`);
        });
      },
      //进入会议
      gotoMeeting(item){
        const {startDate,endDate,id} = item;
        const nowTime = (new Date()).getTime();
        if(startDate <nowTime && nowTime<endDate){
          //进行中
           this.$router.push({name: 'DailyDetail',params:{}});
          saveLocalStorage(id, 'formid')
        }else if(nowTime > endDate){
          //已结束
          this.$message.error("会议已结束");
        }else if(nowTime < startDate){
          //未开始
          this.$message.error("会议未开始");
        }


      },
      //当日要参加的每日读片列表
      getReadMeetListForDay(){
        this.readMeetList = [];
        http.post('/meetIndex/getReadMeetListForDay.json', {}).then(res => {
            if (res.data.code === _.ERR_OK) {
              const data = res.data.model;
              if(data && data.length>0){
                data.forEach(item => {
                  const {confType,status,endDateStr,startDateStr,confName} = item;
                  //将时间拼在名字后面
                  const startTime = startDateStr.split(" ")[1];
                  const endTime = endDateStr.split(" ")[1];
                  item.confName = `${confName} ( ${startTime}-${endTime} )`
                  //会议类型（1-晨读会 2-业务学习）
                  //会议状态0未开始1结束2过期3进行中
                  if(confType === 1){
                    item.confTypeName = "晨读会";
                  }else{
                    item.confTypeName = "业务学习）";
                  }
                  if(status === 0){
                    item.statusName = "未开始";
                  }else if(status === 1){
                    item.statusName = "结束";
                  }else if(status === 2){
                    item.statusName = "过期";
                  }else{
                    item.statusName = "进行中";
                  }
                });
                this.readMeetList = data;
              }

            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e=>{
           // this.$message.error(`网络错误，${e}`);
          });
      },
      //按日期查询会议和事件数量
      getMeetCountForEveryDay(){
        //判断日期选择是否正确  点击其他地方dpDate的值 会变成这样 2019-2-
        const dateList = this.dpDate.split("-");
        if(dateList[2]===""){
          return;
        }
        const params = {
          startDate:this.dpDate ,
          endDate:this.dpDate
        }
        http.post('/meetIndex/getMeetCountForEveryDay.json', params).then(res => {
            if (res.data.code === _.ERR_OK) {
              const data = res.data.model;
              const {everyDayCount,topicMeetCount} = data;

              const allCount = everyDayCount + topicMeetCount;
              this.meetingNum = allCount;
              this.dupian.everyday = everyDayCount;
              this.dupian.special = topicMeetCount;

            } else {
              this.$message.error(res.data.msg);
            }
          }).catch(e=>{
            //this.$message.error(`网络错误，${e}`);
          });
      },
      tabClick(tab, event){
        this.getMeetListByDateTime();

      },
      _operation_(payload){
          //表格操作
        http.post('/getUserInfo.json').then(res => {
          if (res.data.code === _.ERR_OK) {
            const confChairName = res.data.model.userName
            const conTime = new Date(res.data.model.doctorSign.replace("-","/")).getTime()
            //进入会议 发送状态（0-保存待发，1-已发送）
            if ((payload.sendState==1 && payload.statusName=='进行中') || (payload.sendState==1 && payload.statusName=='未开始')) {

              this.idVal = payload.id
              saveLocalStorage(payload.id, 'idVal')
              if(payload.hasConfPwd === '1') { //有密码
                this.popPassword = true
                let  startDatetime = payload.startDateStr.replace("-","/");//替换字符，变成标准格式
                this.confTime
                let   d2 = new Date(); //取今天的日期
                let d1 = new Date(Date.parse(startDatetime)); //取会议开始的日期
                let  hosSecond=d1.getTime()-conTime  //时间差的毫秒数
                let  statTime=new Date(payload.startDateStr.replace("-","/")).getTime()
              //  let  startDatetime = payload.startDateStr.replace("-","/");//替换字符，变成标准格式
              //  let d2 = new Date(); //取今天的日期
              //  let  d1 = new Date(Date.parse(startDatetime)); //取会议开始的日期
              //  let  hosSecond=d1.getTime()-conTime  //时间差的毫秒数
              //  let  statTime=new Date(payload.startDateStr).getTime()

                if(hosSecond >= '1800000') {
                  if(payload.confChairName != confChairName) {
                    message('会议不满足进入条件或者用户无权限开始会议', false)
                  } else {message('最多只能提前半小时进入会议', false)

                  }
                } else if(hosSecond < '1800000'&& payload.confChairName == confChairName  && payload.status=='未开始') {
                this.popPassword=false
                this.$confirm('还未到会议时间，是否要提前开始会议', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',

                  }).then(() => {
                    this.popPassword = true
                  })
                } else if(hosSecond < '1800000' && payload.confChairName != confChairName && hosSecond >= '0' && payload.status=='未开始') {
                  message('会议不满足进入条件或者用户无权限开始会议', false)
                } else if(payload.status=='进行中') {
                  this.popPassword = true
                } else if(hosSecond < '0') {
                  this.popPassword = true
                }
              } else {  //无密码

                this.ConfPassword = ''
                saveLocalStorage(this.ConfPassword, 'ConfPasswordVal')
                let params = {
                  id: payload.id,
                  confPwd: this.ConfPassword
                }
                let  startDatetime = payload.startDateStr.replace("-","/");//替换字符，变成标准格式
                this.confTime
                let   d2 = new Date(); //取今天的日期
                let d1 = new Date(Date.parse(startDatetime)); //取会议开始的日期
                let  hosSecond=d1.getTime()-conTime  //时间差的毫秒数
                let  statTime=new Date(payload.startDateStr.replace("-","/")).getTime()

                if(hosSecond >= '1800000') {
                  if(payload.confChairName != confChairName) {
                    message('会议不满足进入条件或者用户无权限开始会议', false)
                  } else {
                    message('最多只能提前半小时进入会议', false)
                  }
                } else if(hosSecond < '1800000'&& payload.confChairName == confChairName && payload.status=='未开始') {
                  this.$confirm('还未到会议时间，是否要提前开始会议', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                  }).then(() => {
                    http.post('/conference/enterTopicConf.json', params).then(res => {

                      if (res.data.code === _.ERR_OK) {
                        this.$router.push({name: 'EnterManageMeeting'})
                        this.popShow = true
                      } else {
                        message(res.data.msg, false)
                      }
                    }).catch(err => {
                      errMsg(err)
                    })
                  })
                } else if(hosSecond < '1800000' && payload.confChairName != confChairName && hosSecond >= '0' && payload.status=='未开始') {
                  message('会议不满足进入条件或者用户无权限开始会议', false)
                }
                else {
                  http.post('/conference/enterTopicConf.json', params).then(res => {

                    if (res.data.code === _.ERR_OK) {
                      this.$router.push({name: 'EnterManageMeeting'})
                      this.popShow = true
                    } else {
                      message(res.data.msg, false)
                    }
                  }).catch(err => {
                    errMsg(err)
                  })
                }
              }
            }
          }
        }).catch((e) => {
          console.error(e)
        })
      },
      closePassword(payload) {  //关闭输入密码弹窗
        this.popPassword = payload
      },
      _cancelPass() {
        this.ConfPassword = ''
        this.popPassword = false
      },
      _inputDetail(psw) { //输入密码弹窗点击确认
          this.ConfPassword = psw;
          let params = {
            id: this.idVal,
            confPwd: psw
          }

          http.post('/conference/enterTopicConf.json', params).then(res => {
            if (res.data.code === _.ERR_OK) {
               this.popPassword = false
              this.$router.push({name: 'EnterManageMeeting'})
              this.popShow = true
            } else {
              message(res.data.msg, false)
            }
          }).catch(err => {
            errMsg(err)
          })
      },
      /*获取当前时间*/
      getDay(day){
        var today = new Date();
        var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
        today.setTime(targetday_milliseconds); //注意，这行是关键代码
        var tYear = today.getFullYear();
        var tMonth = today.getMonth();
        var tDate = today.getDate();
        tMonth = this.doHandleMonth(tMonth + 1);
        tDate = this.doHandleMonth(tDate);
        return tYear+"-"+tMonth+"-"+tDate;
      },
      doHandleMonth(month){
        var m = month;
        if(month.toString().length == 1){
          m = "0" + month;
        }
        return m;
      },
      _getDay(data){
        const {year,month,day} = data;
        this.dpDate =  year+"-"+month+"-"+day;
        this.getMeetCountForEveryDay();
      },
      init_Data(){

		this.getUserInfo();
        this.dpDate = this.getDay(0);
        this.getMeetCountForEveryDay();
        this.getReadMeetListForDay();
        this.getCaseCourseCount();
        this.getMeetListByDateTime();
      }
    },

    created() {
      const that=this;
      const isSearch =  this.$route.query.isSearch;
      if(isSearch){
         that.$events.$on("getUserInfo",()=>{
          that.init_Data();
        })
      }else{
        that.init_Data();
      }
    },
    beforeDestroy(){
      this.$events.$off("getUserInfo");
    }
  }
</script>
<style  lang="stylus" rel="stylesheet/stylus">
  .entryPageMain .el-tabs__content
    height:calc( 100% - 60px );
</style>
<style scoped lang="stylus" rel="stylesheet/stylus">
  .entryPageMain
    width:100%
  .entryPage
    position:relative
    height: calc(100vh - 50px)
    overflow-y: auto
  .entryPage-Con
    width: calc(100% - 40px)
    margin: 20px auto

  .shadow-box
    box-shadow: 0 0 20px 3px rgba(0, 0, 0, 0.1)

  .ep-top,.ep-bottom
    width: 100%
    zoom:1
  .ep-top
    height:calc(46% - 27.6px)
  .ep-bottom
    height:calc(54% - 32.4px)

  .ep-top:after,.ep-bottom:after
    clear:both
    content:''
    display:block
    width:0
    height:0
    visibility:hidden

  .doc-info, .entrance, .data-statistic
    //height: 280px
    min-height:239.2px
    max-height:400px
    height: calc(46vh - 50.6px)
    float: left
    background:#fff

  .doc-info
    // width: 320px
    width: 30%;
    .doc-info-h
      height: 30%
      background:#42B8B8
    .doc-info-con
      display:flex
      flex-direction:column
      align-items :center
      position:relative
      height:calc(70% - 9vh)
      padding-top:9vh
      .doc-pic
        position:absolute
        left: 50%
        top: 0
        transform:translate(-50%,-50%)
        width:110px
        height:110px
        padding: 5px
        border-radius:60px
        background:#fff
        overflow:hidden
        img
          width: 110px
          max-height:110px
          border-radius:55px
      h2
        color: #000000
        font-weight:bold
        line-height:36px
        font-size: 20px
        text-align:center
      .doc-label
        display:flex
        justify-content:center
        line-height:36px
        span
          padding:0 6px
      p
        color:#000
        text-align:center
        line-height:40px
        strong
          color:#42B8B8
          font-size:20px
          font-weight:bold;

  .entrance
    padding:0 16px
    // width: calc(72% - 392px)
    width: calc(40% - 105px);

    margin: 0 20px
    .entrance-list1
      height:calc(54% - 21.6px)
      display: flex
      justify-content:center
      align-items :center
      li
        width:25%
        text-align:center
        //height:100px
        .linkto
          display:inline-block
          .choose
            display:flex
            justify-content:center
            align-items:center
            width:60px
            height:60px
            margin-bottom:10px
            -webkit-border-radius: 40px
            -moz-border-radius: 40px
            border-radius: 40px
            i
              width: 40px
              height:40px
              // background:#fff
          .medicalRecord
            background:#6495E1
          .courseWare
            background:#53A9DB
          .course
            background:#4DADD7
          .conference
            background:#4ABBCF
          p
            color:#000
    .entrance-list2
      height:calc(46% - 18.4px)
      overflow-y: auto;
      overflow-x: hidden;
      // display:flex
      // flex-wrap:wrap
      // align-items :center
      .invalid
        color:#C2C5CC
        .enter,.square
          background:#C2C5CC
      li
        width:100%
        position:relative
        padding-left:14px
        line-height: 24px
        // height: 24px
        margin-bottom:10px
        color:#000
        .square
          position:absolute
          width: 8px
          height: 8px
          background:#42B8B8
          left: 0
          top: 8px
        .entrance-main
          float:left
          width :75%
        .enter
          float:right
          width:18%
          height:24px
          background:#42B8B8
          color:#fff
          text-align:center
          border-radius:3px
          cursor: pointer
          margin-right: 17px;
        .enter:hover
          background:#428e8e
        .noEnter
          background:#8791a2
          cursor: not-allowed;
        .noEnter:hover
          background:#8791a2
        strong
          color:red
          margin-right:6px
        .clear
          clear:both

  .data-statistic
    padding:0 16px
    width: 30%
    // width: calc(28% - 32px)
    .statistics
      height:calc(100% - 36px)
      display:flex
      flex-wrap:wrap
      align-items :center
      li
        display:flex
        min-height:50px
        height:20%
        width: 48%
        margin-left:2%
        span
          height: 100%
          width: 8px
          border-radius:4px 0 0 4px
        .statistics-data
          margin-left:18px
          strong
            display:flex
            align-items :center
            height: 60%
            font-size: 20px
            font-weight:bold
            color:#000
          p
            display:flex
            align-items :center
            height: 40%
      .statistic1
        span
          background:#6495E1
      .statistic2
        span
          background:#53A9DA
      .statistic3
        span
          background:#4BBBD1

  .ep-bottom
    margin-top:20px
    width: 100%

  .calendar, .meeting
    //height: 300px
    min-height: 280.8px   //根据最小高度630px计算
    max-height:500px
    height: calc(54vh - 59.4px)
    float: left
    background:#fff

  .calendar
    // width: 320px
    width: 30%
    .doc-title
      padding-left:16px

  .meeting
    // width: calc(100% - 340px)
    width: calc(70% - 52px);
    margin-left:20px;
    padding:0 16px;

  .doc-title
    height:36px
    line-height:36px
  .dp-title
    height: 49px
    line-height: 49px
    display:flex
    align-items :center
    justify-content :center
    span
      width:1px
      height: 30px
      background:#F2F2F3
    p
      width: 40%
      text-align:center
      color:#000
      strong
        color:#00ABAD
        font-weight:bold
        font-size:18px

  .beginning
    color:red !important
  .begin
    color:#23BA15 !important

  .message
    position:absolute
    right: 20px
    bottom: 20px
    z-index:100
</style>



// WEBPACK FOOTER //
// entryPage.vue?2918a3dc